/**
 * Formatea una fecha con hora en formato español
 * Formato: "Domingo, 25 octubre 2026 - 15:30 hrs"
 * 
 * @param {string} dateString - Fecha en formato ISO o string válido para Date
 * @returns {string} - Fecha formateada con hora
 */
export const formatDateWithTime = (dateString) => {
  if (!dateString) return "Fecha inválida";
  
  try {
    // Parsear fecha ISO 8601 correctamente
    const date = new Date(dateString);
    
    // Validar que la fecha sea válida
    if (isNaN(date.getTime())) {
      return "Fecha inválida";
    }
    
    const dateFormatted = date.toLocaleDateString("es-ES", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    const timeFormatted = date.toLocaleTimeString("es-ES", {
      hour: "2-digit",
      minute: "2-digit",
    });
    return `${dateFormatted} - ${timeFormatted} hrs`;
  } catch (error) {
    console.error("Error al formatear fecha:", error, dateString);
    return "Fecha inválida";
  }
};

/**
 * Formatea una fecha sin hora en formato español
 * Formato: "25 octubre 2026"
 * 
 * @param {string} dateString - Fecha en formato ISO o string válido para Date
 * @returns {string} - Fecha formateada sin hora
 */
export const formatDateOnly = (dateString) => {
  if (!dateString) return "Fecha inválida";
  
  try {
    const date = new Date(dateString);
    
    if (isNaN(date.getTime())) {
      return "Fecha inválida";
    }
    
    return date.toLocaleDateString("es-ES", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  } catch (error) {
    console.error("Error al formatear fecha:", error, dateString);
    return "Fecha inválida";
  }
};

/**
 * Formatea una fecha con día de la semana
 * Formato: "Domingo, 25 de octubre de 2026"
 * 
 * @param {string} dateString - Fecha en formato ISO o string válido para Date
 * @returns {string} - Fecha formateada con día de la semana
 */
export const formatDateFull = (dateString) => {
  if (!dateString) return "Fecha inválida";
  
  try {
    const date = new Date(dateString);
    
    if (isNaN(date.getTime())) {
      return "Fecha inválida";
    }
    
    return date.toLocaleDateString("es-ES", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  } catch (error) {
    console.error("Error al formatear fecha:", error, dateString);
    return "Fecha inválida";
  }
};
